module.exports = __webpack_public_path__ + "static/media/kivra.d0c29d9e.svg";